var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2139 2.60925H5.57101C5.25494 2.60925 4.99958 2.86461 4.99958 3.18068V7.39497H0.785296C0.469224 7.39497 0.213867 7.65032 0.213867 7.9664V12.8235C0.213867 13.1396 0.469224 13.395 0.785296 13.395H10.4282C10.7442 13.395 10.9996 13.1396 10.9996 12.8235V8.60925H15.2139C15.5299 8.60925 15.7853 8.3539 15.7853 8.03782V3.18068C15.7853 2.86461 15.5299 2.60925 15.2139 2.60925ZM6.21387 3.82354H9.7853V7.39497H6.21387V3.82354ZM4.99958 12.1807H1.42815V8.60925H4.99958V12.1807ZM9.7853 12.1807H6.21387V8.60925H9.7853V12.1807ZM14.571 7.39497H10.9996V3.82354H14.571V7.39497Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpql);
export default __webpack_public_path__ + "static/media/SPQL.25e6704fa0dc07f33525444cb6f5fc88.svg";
export { ForwardRef as ReactComponent };